import React, { useEffect, useState } from "react";
import { FiLink2, } from "react-icons/fi";
import { FaUnlink } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  getSettingProfilesByClient,
  linkProfileToMCU,
  unlinkProfileFromMCUByMcuId,
} from "../api/settingProfileApi";
import { useAuth } from "../context/AuthContext";
import { useSocket } from "../context/SocketContext";

const LinkProfileSelector = ({ mcu_id,mac, profile_id ="" }) => {
  const { clientData } = useAuth();
  const [profiles, setProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const [linkedProfile, setLinkedProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
    const {refreshCommand}=useSocket();

  useEffect(() => {
    const loadProfiles = async () => {
      if (!clientData?.client_id) return;
      try {
        const all = await getSettingProfilesByClient(clientData.client_id);
        setProfiles(all);

        // const linked = all.find((p) =>
        //   p.mcu_links?.some((link) => link.mcu_id === mcu_id)
        // );
        const linked = all.find((p) =>
          p?.profile_id===profile_id
        );
        setLinkedProfile(linked || null);
        setSelectedProfileId(profile_id || linked?.profile_id || "");
      } catch (err) {
        toast.error("Failed to load setting profiles");
      }
    };
    loadProfiles();
  }, [clientData, mcu_id, profile_id]);

  const handleLink = async (e) => {
    const profile_id = e.target.value;
    const previousId = selectedProfileId;
    setSelectedProfileId(profile_id);
    // Choosing "Select a profile" acts as unlink
    if (!profile_id) {
      if (linkedProfile) await handleUnlink(previousId);
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    try {
      // Server replaces the old link and pushes the new settings to the MCU
      await linkProfileToMCU({ profile_id, mcu_id });
      toast.success("Profile linked to MCU");
      const profile = profiles.find((p) => String(p.profile_id) === String(profile_id));
      setLinkedProfile(profile || null);
      // Fallback push over the dashboard socket (harmless if server already pushed)
      refreshCommand(mcu_id, mac);
    } catch (err) {
      setSelectedProfileId(previousId);
      toast.error("Failed to link profile");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUnlink = async (restoreId = selectedProfileId) => {
    if (!linkedProfile || isLoading) return;
    if (!window.confirm("Are you sure you want to unlink this profile?")) {
      setSelectedProfileId(restoreId);
      return;
    }
    setIsLoading(true);
    try {
      // Unlink by MCU, not by a (possibly stale) link id from the profile list
      await unlinkProfileFromMCUByMcuId(mcu_id);
      toast.success("Profile unlinked");
      setLinkedProfile(null);
      setSelectedProfileId("");
      refreshCommand(mcu_id, mac);
    } catch (err) {
      setSelectedProfileId(restoreId);
      toast.error("Failed to unlink profile");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">Link Profile</label>
      <div className="flex items-center space-x-3">
        <select
          className="px-3 py-2 border rounded-lg w-full"
          value={selectedProfileId || ""}
          onChange={handleLink}
          disabled={isLoading}
        >
          <option value="">Select a profile</option>
          {profiles.map((profile) => (
            <option key={profile.profile_id} value={profile.profile_id}>
              {profile.name}
            </option>
          ))}
        </select>

        {linkedProfile && (
          <button
            onClick={() => handleUnlink()}
            disabled={isLoading}
            className="p-2 text-red-600 hover:text-red-800 bg-red-50 rounded-lg"
          >
            <FaUnlink className="w-4 h-4" />
          </button>
        )}
      </div>

      {linkedProfile && (
        <div className="text-sm text-gray-600 flex items-center space-x-2">
          <FiLink2 className="w-4 h-4 text-green-600" />
          <span>Linked to: {linkedProfile.name}</span>
        </div>
      )}
    </div>
  );
};

export default LinkProfileSelector;
